import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { AdminComponent } from './admin/admin.component';
import { AdminHomeComponent } from './admin-home/admin-home.component';
import { StationsComponent } from './store-management/stations/stations.component';
import { NgxGaugeModule } from 'ngx-gauge';
import { ProductionOverviewComponent } from './admin-dashboard/production-overview/production-overview.component';
import { SellThroughReportComponent } from './admin-dashboard/sell-through-report/sell-through-report.component';
import { TopPerformerComponent } from './admin-dashboard/top-performer/top-performer.component';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { MatNativeDateModule } from '@angular/material/core';
import { Daterangepicker } from 'ng2-daterangepicker';
import { GoalsComponent } from './company-config/goals/goals.component';
import { WeekColorsComponent } from './company-config/WeekColors/Components/week-colors/week-colors.component';
import { QualityComponent } from './company-config/quality/quality.component';
import { PricingComponent } from './company-config/pricing/pricing.component';
import { PricingConfigComponent } from './company-config/pricing-config/pricing-config.component';
import { ItemOnHandComponent } from './inventory-management/item-on-hand/item-on-hand.component';
import { AuthenticationGuard } from '../../authentication.guard';
import { LifecycleReportGuard } from './admin-services/lifecycle-report.guard';
import { SizingComponent } from './company-config/sizing/sizing.component';
import { DragDropModule } from '@angular/cdk/drag-drop';
import { OutsideClickDirective } from '../../outside-click.directive';
import { EmpReportsComponent } from './admin-dashboard/emp-reports/emp-reports.component';
import { LabelsComponent } from './company-config/labels/labels.component';
import { AddNewPricingComponent } from './company-config/add-new-pricing/add-new-pricing.component';
import { ConditionsComponent } from './company-config/conditions/conditions.component';
import { BarcodeComponent } from './barcode/barcode.component';
import { MatStepperModule } from '@angular/material/stepper';
import { NgxPermissionsModule } from 'ngx-permissions';
import { DaterangeComponent } from './daterange/daterange.component';
import { OverrideComponent } from './inventory-management/override/override.component';
import { MatTooltipModule } from '@angular/material/tooltip';
import { SellThroughReportv2Component } from './admin-dashboard/sell-through-reportv2/sell-through-reportv2.component';
import { EmpReportsv2Component } from './admin-dashboard/emp-reportsv2/emp-reportsv2.component';
import { AddWeekColorsComponent } from './company-config/WeekColors/Components/add-week-colors/add-week-colors.component';
import { ContainersComponent } from './inventory-management/Container/Component/containers/containers.component';
import { AddUpdateContainerComponent } from './inventory-management/Container/Component/add-update-container/add-update-container.component';
import { SalePerProducerReportComponent } from './admin-dashboard/sale-per-producer-report/components/sale-per-producer-report/sale-per-producer-report';
import { AnalyticsDashboardComponent } from './analytics/analytics-dashboard.component';
import { AnalyticsViewComponent } from './analytics/analytics-view.component';
import { SellThroughReportV3Component } from './admin-dashboard/reports-v3/sell-through-reportv3/sell-through-reportv3.component';
import { EmpReportsV3Component } from './admin-dashboard/reports-v3/emp-reportsv3/emp-reportsv3.component';
import { TopPerformerV3Component } from './admin-dashboard/reports-v3/top-performerv3/top-performerv3.component';
import { SalePerProducerReportV3Component } from './admin-dashboard/reports-v3/sale-per-producer-reportv3/sale-per-producer-reportv3.component';
import { ProductionOverviewDashboardV3Component } from './admin-dashboard/reports-v3/production-overview-v3/production-overview-dashboard-v3/production-overview-dashboard-v3.component';
import { ProductionOverviewTableV3Component } from './admin-dashboard/reports-v3/production-overview-v3/production-overview-table-v3/production-overview-table-v3.component';
import { ProductionOverviewAdminDashboardV3Component } from './admin-dashboard/reports-v3/production-overview-v3/production-overview-admin-dashboard-v3/production-overview-admin-dashboard-v3.component';
import { ProductionOverviewAdminTableV3Component } from './admin-dashboard/reports-v3/production-overview-v3/production-overview-admin-table-v3/production-overview-admin-table-v3.component';

@NgModule({
  declarations: [
    TopPerformerComponent,
    ProductionOverviewComponent,
    AdminComponent,
    AdminHomeComponent,
    StationsComponent,
    GoalsComponent,
    WeekColorsComponent,
    LabelsComponent,
    QualityComponent,
    ConditionsComponent,
    PricingComponent,
    PricingConfigComponent,
    AddNewPricingComponent,
    ItemOnHandComponent,
    SizingComponent,
    OutsideClickDirective,
    EmpReportsComponent,
    SellThroughReportComponent,
    BarcodeComponent,
    DaterangeComponent,
    OverrideComponent,
    SellThroughReportv2Component,
    EmpReportsv2Component,
    AddWeekColorsComponent,
    ContainersComponent,
    AddUpdateContainerComponent,
    SalePerProducerReportComponent,
    AnalyticsDashboardComponent,
    AnalyticsViewComponent,
    SellThroughReportV3Component,
    EmpReportsV3Component,
    TopPerformerV3Component,
    SalePerProducerReportV3Component,
    ProductionOverviewDashboardV3Component,
    ProductionOverviewTableV3Component,
    ProductionOverviewAdminDashboardV3Component,
    ProductionOverviewAdminTableV3Component
  ],
  imports: [
    MatStepperModule,
    CommonModule,
    CommonModule,
    FormsModule,
    NgxGaugeModule,
    ReactiveFormsModule,
    MatDatepickerModule,
    MatFormFieldModule,
    MatInputModule,
    MatNativeDateModule,
    MatSelectModule,
    MatTooltipModule,
    Daterangepicker,
    DragDropModule,
    NgxPermissionsModule.forChild(),
    RouterModule.forChild([
      {
        path: 'home',
        component: AdminComponent,
        children: [
          {
            path: 'admin-home',
            component: AdminHomeComponent,
            canActivate: [AuthenticationGuard],
            data: { permission: 'General' }
          },
          {
            path: 'top-performer',
            component: TopPerformerComponent,
            canActivate: [AuthenticationGuard],
            data: { permission: 'Report:ViewTopPerformer' }
          },
          {
            path: 'production-overview',
            component: ProductionOverviewComponent,
            canActivate: [AuthenticationGuard],
            data: { permission: 'Report:ViewProductionOverview' }
          },
          {
            path: 'sell-through',
            component: SellThroughReportComponent,
            canActivate: [AuthenticationGuard],
            data: { permission: 'Report:ViewSellThrough' }
          },
          {
            path: 'sell-throughv2',
            component: SellThroughReportv2Component,
            canActivate: [AuthenticationGuard],
            data: { permission: 'Report:ViewSellThrough' }
          },
          {
            path: 'sale-per-producer-report',
            component: SalePerProducerReportComponent
            // canActivate: [AuthenticationGuard],
            // data: { permission: 'Report:ViewSellThrough' }
          },
          {
            path: 'emp-report',
            component: EmpReportsComponent,
            canActivate: [AuthenticationGuard],
            data: { permission: 'Report:ViewEmployee' }
          },
          {
            path: 'emp-reportv2',
            component: EmpReportsv2Component,
            canActivate: [AuthenticationGuard],
            data: { permission: 'Report:ViewEmployee' }
          },
          {
            path: 'v3',
            children: [
              {
                path: 'sell-through',
                component: SellThroughReportV3Component,
                canActivate: [AuthenticationGuard, LifecycleReportGuard],
                data: { permission: 'Report:ViewSellThrough', reportKey: 'sellThrough' }
              },
              {
                path: 'emp-report',
                component: EmpReportsV3Component,
                canActivate: [AuthenticationGuard, LifecycleReportGuard],
                data: { permission: 'Report:ViewEmployee', reportKey: 'empReport' }
              },
              {
                path: 'top-performer',
                component: TopPerformerV3Component,
                canActivate: [AuthenticationGuard, LifecycleReportGuard],
                data: { permission: 'Report:ViewTopPerformer', reportKey: 'topPerformer' }
              },
              {
                path: 'sale-per-producer-report',
                component: SalePerProducerReportV3Component,
                canActivate: [LifecycleReportGuard],
                data: { reportKey: 'salePerProducer' }
              },
              {
                path: 'production-overview',
                component: ProductionOverviewDashboardV3Component,
                canActivate: [AuthenticationGuard, LifecycleReportGuard],
                data: { permission: 'Report:ViewProductionOverview', reportKey: 'productionOverview' }
              },
              {
                path: 'production-overview-table',
                component: ProductionOverviewTableV3Component,
                canActivate: [AuthenticationGuard, LifecycleReportGuard],
                data: { permission: 'Report:ViewProductionOverview', reportKey: 'productionOverview' }
              },
              {
                path: 'production-overview-admin',
                component: ProductionOverviewAdminDashboardV3Component,
                canActivate: [AuthenticationGuard, LifecycleReportGuard],
                data: { permission: 'General', reportKey: 'productionOverview' }
              },
              {
                path: 'production-overview-admin-table',
                component: ProductionOverviewAdminTableV3Component,
                canActivate: [AuthenticationGuard, LifecycleReportGuard],
                data: { permission: 'General', reportKey: 'productionOverview' }
              }
            ]
          },
          {
            path: 'stations',
            component: StationsComponent,
            canActivate: [AuthenticationGuard],
            data: { permission: 'Station:View' }
          },
          {
            path: 'analytics/:mappingId',
            component: AnalyticsViewComponent
          },
          {
            path: 'barcode',
            component: BarcodeComponent,
            canActivate: [AuthenticationGuard],
            data: { permission: 'General' }
          },
          {
            path: 'pricing',
            component: PricingComponent,
            canActivate: [AuthenticationGuard],
            data: { permission: 'General' },
            children: [
              {
                path: 'pricing-config',
                component: PricingConfigComponent,
                canActivate: [AuthenticationGuard],
                data: { permission: 'Pricing:View' }
              },
              {
                path: 'add-pricing',
                component: AddNewPricingComponent,
                canActivate: [AuthenticationGuard],
                data: { permission: 'Pricing:Create' }
              }
            ]
          },

          {
            path: 'grades',
            component: QualityComponent,
            canActivate: [AuthenticationGuard],
            data: { permission: 'General' }
          },
          {
            path: 'labels',
            component: LabelsComponent,
            canActivate: [AuthenticationGuard],
            data: { permission: 'Label:View' }
          },
          {
            path: 'goals',
            component: GoalsComponent,
            canActivate: [AuthenticationGuard],
            data: { permission: 'Goal:View' }
          },
          {
            path: 'sizing',
            component: SizingComponent,
            canActivate: [AuthenticationGuard],
            data: { permission: 'Size:View' }
          },
          {
            path: 'week-colors',
            component: WeekColorsComponent,
            canActivate: [AuthenticationGuard],
            data: { permission: 'WeekColor:View' }
          },
          {
            path: 'overrides',
            component: OverrideComponent,
            canActivate: [AuthenticationGuard],
            data: { permission: 'WeekColor:Override' }
          },
          {
            path: 'onhands',
            component: ItemOnHandComponent,
            canActivate: [AuthenticationGuard],
            data: { permission: 'Item:ViewItemsOnHand' }
          },
          {
            path: 'containers',
            component: ContainersComponent
          }
        ]
      }
    ])
  ]
})
export class AdminModule { }
